import { status, StatusType } from '../typeStatus'

export const GET_CURRENCY = 'GET_CURRENCY'
export const GET_CURRENCY_SUCCESS = 'GET_CURRENCY_SUCCESS'
export const GET_CURRENCY_ERROR = 'GET_CURRENCY_ERROR'


export interface CurrencyInfo {
  codigo: string
  simbolo: string
  nombre: string
  id: number
}

export interface CurrencyState {
  idPais: CurrencyInfo[]
  status: StatusType
}

export const initialState: CurrencyState = {
  idPais: [],
  status: status.initial,
}

export interface GetCurrency {
  type: typeof GET_CURRENCY
  payload: []
}

export interface GetCurrencySuccess {
  type: typeof GET_CURRENCY_SUCCESS
  payload: CurrencyInfo[]
}

export interface GetCurrencyError {
  type: typeof GET_CURRENCY_ERROR
  payload: boolean
}

export type CurrencyActions = GetCurrency | GetCurrencySuccess | GetCurrencyError
